import { makeAutoObservable, reaction, runInAction } from "mobx";
import agent from "../../api/agent";
import { ReportInput } from "../../models/reports";
import { PagingParams, Pagination } from "../../models/pagination";
import { DateRangeOption, ReportType } from "../../models/enums";
import { RecommendedInventoryReportDto } from "../../models/inventoryReports";

export default class RecommendedInventoryReportStore {
  constructor() {
    makeAutoObservable(this);
    reaction(
      () => this.predicate.keys(),
      () => {
        this.recommendedInvRegistry.clear();
        this.loadRecommendedInventoryReport();
      }
    );
  }

  loadingInitial = false;
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  reportCriteria: ReportInput = new ReportInput({
    dateRange: DateRangeOption.Today,
    startDate: new Date(),
    endDate: new Date(),
    reportType: ReportType.Summary,
    filter: "0",
  });

  recommendedInvRegistry = new Map<string, RecommendedInventoryReportDto>();

  resetRecommendedInventoryRegistry = () => {
    this.recommendedInvRegistry.clear();
  };

  loadRecommendedInventoryReport = async () => {
    this.loadingInitial = true;
    try {
      this.recommendedInvRegistry.clear();
      const result = await agent.inventoryReports.getRecommendedInventory(this.axiosParams);
      runInAction(() => {
        result.forEach((recom) => {
          this.setRecommendedInvReport(recom);
        });
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.setLoadingInitial(false);
    }
  };

  private setRecommendedInvReport = (recommendedInv: RecommendedInventoryReportDto) => {
    this.recommendedInvRegistry.set(recommendedInv.id ?? "", recommendedInv);
  };

  get getRecommendedInventoryReport() {
    return Array.from(this.recommendedInvRegistry.values()).sort(
      (a, b) => b.quantity! - a.quantity!
    )
  }
  pagingParams = new PagingParams();
  pagination: Pagination | null = null;
  predicate = new Map().set("all", true);

  get axiosParams() {
    const params = new URLSearchParams();
    this.predicate.forEach((value, key) => {
      if (key === "StartDate" || key === "EndDate") {
        params.append(key, (value as Date).toISOString());
      } else {
        params.append(key, value);
      }
    });
    return params;
  }

  setPredicate = (startDate?: Date, endDate?: Date) => {
    const resetPredicate = () => {
      this.predicate.forEach((value, key) => {
        if (key !== "startDate") this.predicate.delete(key);
      });
    };
    resetPredicate();
    if (startDate) this.predicate.set("StartDate", startDate);
    if (endDate) this.predicate.set("EndDate", endDate);
  };

  setReportCriteria = (values: ReportInput) => {
    this.reportCriteria = new ReportInput(values);
  };

}
